import { useState, useCallback } from "react";
import { UIStructuredOutput } from "../../generated/core-api";
import { structuredOutputToText } from "../toPlainText";

interface UseCopyStructuredOutputResult {
  isCopied: boolean;
  handleCopy: () => Promise<void>;
}

export function useCopyStructuredOutput(
  content: UIStructuredOutput
): UseCopyStructuredOutputResult {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      const textToCopy = structuredOutputToText(content);
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy message:", err);
    }
  }, [content]);

  return {
    isCopied,
    handleCopy,
  };
}
